import { Skeleton } from "@mui/material";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "../../../../components";
import { formatNcm } from "../../../../utils";
import PainelAnaliseFiscalProdutosNcmDialog from "./painel-analise-fiscal-produtos-ncm-dialog";
import { useState } from "react";
import shortid from "shortid";

export default function PainelAnaliseFiscalProdutosNcm({
  loading = false,
  analiseFiscalAi = {
    produtosAnalisados: 0,
    ncmsComInconsistencia: 0,
    gruposTributacaoIncorretos: 0,
    ncmsInconsistentes: [],
    gruposIncorretos: [],
  },
  revisarProdutoAnaliseFiscal,
}) {
  const [openDialogProdutosNcm, setOpenDialogProdutosNcm] = useState(false);
  return (
    <Grid item xs={12} md={6}>
      <Card
        sx={{
          borderRadius: 3,
          border: "1px solid #f0f0f0",
          height: "100%",
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <div>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                NCMs com inconsistência
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                NCMs inválidos, genéricos ou incompatíveis
              </Typography>
            </div>
            {analiseFiscalAi.ncmsInconsistentes?.length > 0 && (
              <Box display="flex" justifyContent="end">
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  className="gap-2"
                  onClick={() => setOpenDialogProdutosNcm(true)}
                >
                  Revisar NCMs
                  <i
                    className="ph-bold ph-arrow-square-out"
                    style={{ color: "#64748b", fontSize: 15 }}
                  />
                </Button>
              </Box>
            )}
          </Box>
          <Divider sx={{ mb: 2 }} />
          {loading ? (
            <Box>
              {[1, 2, 3, 4].map((i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  height={40}
                  sx={{ mb: 1, borderRadius: 1 }}
                />
              ))}
            </Box>
          ) : (
            <Box>
              <Table size="small" className="mt-3">
                <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700, minWidth: 250 }}>
                      Produto
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, minWidth: 120 }}>
                      NCM Atual
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, minWidth: 120 }}>
                      NCM Sugerido
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {analiseFiscalAi.ncmsInconsistentes.map((item, idx) => (
                    <TableRow
                      key={item.descricao || idx}
                      sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}
                    >
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          {item.descricao || "—"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            item.ncmCodigo ? formatNcm(item.ncmCodigo) : "—"
                          }
                          size="small"
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            item.ncmSugerido ? formatNcm(item.ncmSugerido) : "—"
                          }
                          size="small"
                          color="success"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}
        </CardContent>
      </Card>
      <PainelAnaliseFiscalProdutosNcmDialog
        open={openDialogProdutosNcm}
        setOpen={setOpenDialogProdutosNcm}
        revisarProdutoAnaliseFiscal={revisarProdutoAnaliseFiscal}
        ncmsInconsistentes={(analiseFiscalAi.ncmsInconsistentes || []).map(
          (item) => ({
            ...item,
            id: shortid.generate(),
          }),
        )}
      />
    </Grid>
  );
}
